import {createSlice} from "@reduxjs/toolkit";
import Nullable from "@/types/utils/Nullable";
import State from "@/types/utils/State";
import { ILocalizacao } from "@/types/IImpressoResponse";

type AlertType = 'success' | 'error'

interface IAlert{
    message?: Nullable<string>
    show: boolean
    type?: AlertType
}


export interface SliceAddress {
    bairro: string;
    cep: string;
    cidade: string;
    numero: number;
    logradouro: string;
    complemento: string;
    pais: string;
    sigla_pais: string;
    uf: string;
    escritorio?: number;
    ponto_ref: string;
    dica_entrega: string;
    dica_entrega_input: string;
  }
export interface IUserValue {
    nome?: string
    sobre_nome?: string
    email: string
    id_usuario: number
    telefone?: string
    documento?: string
    alert?: IAlert
    address?: SliceAddress
    assinante?: boolean
}

const initialState: State<IUserValue> = {
    value: {
        nome: '',
        sobre_nome: '',
        email: '',
        id_usuario: 0,
        telefone: '',
        documento: '',
        assinante: false,
        alert: {
            message: null,
            show: false,
            type: 'error'
        },
        address:{
            bairro: '',
            cep: '',
            cidade: '',
            numero: 0,
            logradouro: '',
            complemento: '',
            pais: 'Brasil',
            sigla_pais: 'BR',
            uf: '',
            ponto_ref: '',
            dica_entrega: '',
            dica_entrega_input: '',
        }
    }
}

export const usuarioSlice = createSlice({
    name: "usuario",
    initialState,
    reducers: {
        SET_USER: (state, action: {payload: IUserValue}) => {
            if (typeof action.payload !== 'undefined') {
                const {payload} = action
                state.value.nome = payload.nome;
                state.value.sobre_nome = payload.sobre_nome;
                state.value.email = payload.email
                state.value.id_usuario = payload.id_usuario
                state.value.telefone = payload.telefone
                state.value.documento = payload.documento
                state.value.assinante = payload.assinante
            }
        },
        SET_USER_ALERT: (state, action: {payload: IAlert}) => {
            const {payload} = action
            if(state.value.alert){
                state.value.alert.show = payload.show;
                state.value.alert.message = payload.message
                state.value.alert.type = payload.type
            }
        },
        SET_USER_ADDRESS: (state, action: {payload: SliceAddress}) => {
            const {payload} = action
            if(state.value.address){
                state.value.address.bairro = payload.bairro;
                state.value.address.cep = payload.cep;
                state.value.address.cidade = payload.cidade;
                state.value.address.numero = payload.numero;
                state.value.address.logradouro = payload.logradouro;
                state.value.address.complemento = payload.complemento;
                state.value.address.pais = payload.pais;
                state.value.address.sigla_pais = payload.sigla_pais;
                state.value.address.uf = payload.uf;
                state.value.address.ponto_ref = payload.ponto_ref;
                state.value.address.dica_entrega = payload.dica_entrega;
                state.value.address.dica_entrega_input = payload.dica_entrega_input;  
                state.value.address.escritorio = payload.escritorio;
            }       
        }
    }
})

export const {SET_USER} = usuarioSlice.actions
export const {SET_USER_ALERT} = usuarioSlice.actions
export const {SET_USER_ADDRESS} = usuarioSlice.actions

export const GET_USER = (state: any): IUserValue => state.usuario.value
export const GET_USER_ALERT = (state: any): IAlert => state.usuario.value.alert
export const GET_USER_ADDRESS = (state: any): SliceAddress => state.usuario.value.address
export default usuarioSlice.reducer